import {
    // Constants
    UI_SETTINGS_CHANGED,
    FORGET_ALL,

    // Actions
    isLoaded,
    saveUiSettings,
    markAsLoaded,

    // Selectors
    getAutoLaunchOnLogin,
    getAutoLaunchOnStartup,
    getLayout,
    getLaunchDelay,
} from './data'

// Reducer is exposed so that we can hook it up to the store creation
export { default as settingsReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Constants are exposed as a way for settings to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    UI_SETTINGS_CHANGED, // LocalForageMiddleware
    FORGET_ALL_USERS: FORGET_ALL, // LogoutMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    saveUiSettings, // localforage
    markAsLoaded, // index.js
}

// Selectors are a way to expose the internal state of this feature to those
// who are interested
export const selectors = {
    areUiSettingsLoaded: isLoaded, // App
    getAutoLaunchOnLogin, // Backend feature & LoginWindow container
    getAutoLaunchOnStartup, // UserList container
    getLayout, // MainSection container, UserList container & Toaster feature
    getLaunchDelay, // UserList container
}



// WEBPACK FOOTER //
// ./src/features/Settings/exports.js